import React from 'react';
import { useTheme } from '@mui/material/styles';
import { IconButton as MuiIconButton, Tooltip } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { ChatBubbleRounded, Close } from '@mui/icons-material';

export const IconButton = (props) => {
  const { icon, customIcon, imgSrc, imgAlt, label, tooltip, disabled, size, sx, ...rest } = props;

  const theme = useTheme();

  let iconSize = 25;
  if (size === 'small') {
    iconSize = 20;
  } else if (size === 'large') {
    iconSize = 64;
  }

  let buttonSize = 40;
  if (size === 'small') {
    buttonSize = 25;
  } else if (size === 'large') {
    buttonSize = 70;
  }
  
  const iconSX = {
    color: theme.palette.green.main,
    fill: theme.palette.green.main,
    height: `${iconSize}px`,
    width: `${iconSize}px`,
  };

  const buttonSX = {
    backgroundColor: `${disabled ? theme.palette.disabled.main : theme.palette.white.main
      } !important`,
    width: `${buttonSize}px`,
    height: `${buttonSize}px`,
    borderRadius: size === 'small' ? '7px' : '10px',
    '& .MuiTouchRipple-root': {
      borderRadius: size === 'small' ? '7px' : '10px',
    },
    boxShadow: '0px 4px 20px rgba(51, 51, 51, 0.2)',
    '&:hover': {
      backgroundColor: `${theme.palette.white.hover} !important`,
    },
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'width 0.2s ease-out, height 0.2s ease-out',
  };

  let IconComponent = customIcon;

  if (icon === 'add') {
    IconComponent = <AddRoundedIcon sx={iconSX} />;
  } else if (icon === 'download') {
    IconComponent = <DownloadRoundedIcon sx={iconSX} />;
  } else if (icon === 'back') {
    IconComponent = <ArrowBackIosRoundedIcon sx={iconSX} />;
  } else if (icon === 'next') {
    IconComponent = <ArrowForwardIosRoundedIcon sx={iconSX} />;
  } else if (icon === 'close') {
    IconComponent = <Close sx={iconSX} />;
  } else if (icon === 'image') {
    IconComponent = imgSrc ? (
      <img
        src={imgSrc}
        alt={imgAlt || 'Chat'}
        style={{
          height: iconSize,
          width: 'auto',
          objectFit: 'contain',
          display: 'flex',
        }}
      />
    ) : (
      <ChatBubbleRounded sx={iconSX} />
    );
  }

  const Button = (
    <MuiIconButton
      variant="contained"
      aria-label={label || rest['aria-label']}
      sx={{ ...buttonSX, ...sx }}
      disabled={disabled}
      {...rest}>
      {IconComponent}
    </MuiIconButton>
  );

  return tooltip ? <Tooltip title={tooltip}>{Button}</Tooltip> : Button;
};

